

export enum ProductStatus {
    ACTIVE = 'Active',
    ARCHIVED = 'Archived',
    DELETED = 'Deleted',
}

export interface ProductFilter {
    modes?: string[];
    defaultShipmentMethod?: string;
    page?: number;
    limit?: number;
    productIds?: string[];
    supplierIds?: string[];
    collectionIds?: string[];
    search?: string;
    daysOfStockMin?: number | null;
    daysOfStockMax?: number | null;
    orderAmountDaysMin?: number | null;
    orderAmountDaysMax?: number | null;
    leadTimeMin?: number | null;
    leadTimeMax?: number | null;
    hasImage?: boolean;
    forecastGrades?: string[];
    active?: boolean;
    /** When false, include products not available for purchase. Omitted/true: purchasable-only (API default). */
    purchasable?: boolean;
    /** Filter to products listed on these marketplaces (from /products/marketplaces) */
    marketplaceIds?: string[];
    /** When true, only products with no marketplace listing */
    noMarketplaceListing?: boolean;
}